import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchKnowTheEntitySection } from "../../../../services/knowTheHost.service";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  SECTION_KNOW_THE_HOST_COMPONENTS,
  STD_ERROR_MESSAGE,
} from "../../../../utils/constant.js";
import AddAboutEntity from "../../add-about-entity/AddAboutEntity";
import KnowTheEntity from "../../know-the-entity/KnowTheEntity";

const SectionKnowTheEntity = (props) => {
  const [loading, setLoading] = useState(true);
  const knowTheHostState = useSelector((state) => state.knowTheHostEm);
  const dispatch = useDispatch();
  const params = useParams();

  const [currentMainComponent, setCurrentMainComponent] = useState({
    currComponent: null,
    prevComponent: null,
  });
  useEffect(() => {
    if (isEmpty(knowTheHostState.response)) {
      dispatch(fetchKnowTheEntitySection(params.entityId));
    }
  }, []);

  useEffect(() => {
    if (!knowTheHostState.loading && !isEmpty(knowTheHostState.response)) {
      if (!isEmpty(knowTheHostState.response.data)) {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent:
              SECTION_KNOW_THE_HOST_COMPONENTS.list_know_the_host_sections,
            prevComponent: prevState.component,
          };
        });
      } else {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent:
              SECTION_KNOW_THE_HOST_COMPONENTS.add_know_the_host_sections,
            prevComponent: prevState.component,
          };
        });
      }
      setLoading(false);
    }
    if (!knowTheHostState.loading && !isEmpty(knowTheHostState.error)) {
      setLoading(false);
      toast.error(
        knowTheHostState.error?.data?.error_data || STD_ERROR_MESSAGE
      );
    }
  }, [knowTheHostState]);
  function getMainComponent() {
    switch (currentMainComponent.currComponent) {
      case SECTION_KNOW_THE_HOST_COMPONENTS.add_know_the_host_sections:
        return (
          <AddAboutEntity
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      case SECTION_KNOW_THE_HOST_COMPONENTS.list_know_the_host_sections:
        return (
          <KnowTheEntity
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      default:
        return null;
    }
  }
  return <>{!loading ? getMainComponent() : null}</>;
};
export default SectionKnowTheEntity;
